import { c as _c } from "react/compiler-runtime";
import { NeutralButton, NeutralTypeEnum, toast } from '@systemeio/ui';
import { useInterruptSpitTest } from 'modules/newsletters/split-test/hooks/use-interrupt-spit-test';
import React, { useState } from 'react';
import ConfirmationModal from 'shared/components/confirmation-modal';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { BlockedIcon } from '@systemeio/ui/icons';
interface InterruptSplitTestProps {
  opened: boolean;
  onClose: () => void;
  afterAbandon: () => Promise<void>;
  mailingSplitTestId: string | undefined;
}
export function InterruptSplitTest(t0) {
  const $ = _c(14);
  const {
    opened,
    onClose,
    afterAbandon,
    mailingSplitTestId
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const abandonSpitTest = useInterruptSpitTest(mailingSplitTestId);
  let t1;
  if ($[0] !== abandonSpitTest || $[1] !== afterAbandon || $[2] !== t) {
    t1 = async () => {
      await abandonSpitTest();
      await afterAbandon();
      toast.success(t("dashboard.newsletter_editor.split_test.interrupt.success"));
    };
    $[0] = abandonSpitTest;
    $[1] = afterAbandon;
    $[2] = t;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const onConfirm = t1;
  let t2;
  if ($[4] !== t) {
    t2 = t("dashboard.newsletter_editor.split_test.interrupt.title");
    $[4] = t;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t) {
    t3 = t("dashboard.newsletter_editor.split_test.interrupt.description");
    $[6] = t;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== onClose || $[9] !== onConfirm || $[10] !== opened || $[11] !== t2 || $[12] !== t3) {
    t4 = <ConfirmationModal title={t2} confirmationText={t3} opened={opened} onClose={onClose} onConfirm={onConfirm} />;
    $[8] = onClose;
    $[9] = onConfirm;
    $[10] = opened;
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  return t4;
}
interface InterruptSplitTestWithButtonProps extends Omit<InterruptSplitTestProps, 'opened' | 'onClose'> {}
export function InterruptSplitTestWithButton(t0) {
  const $ = _c(14);
  const {
    afterAbandon,
    mailingSplitTestId
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const [opened, setOpened] = useState(false);
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => setOpened(true);
    t2 = <BlockedIcon className="main-transition-colors group-hover:fill-danger fill-text-primary h-[16px] w-[16px]" />;
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  if ($[2] !== t) {
    t3 = t("dashboard.newsletter_editor.split_test.interrupt.title");
    $[2] = t;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t3) {
    t4 = <NeutralButton neutralType={NeutralTypeEnum.danger} onClick={t1}>{t2}<span className="hidden lg:flex">{t3}</span></NeutralButton>;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => setOpened(false);
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== afterAbandon || $[8] !== mailingSplitTestId || $[9] !== opened) {
    t6 = <InterruptSplitTest mailingSplitTestId={mailingSplitTestId} opened={opened} onClose={t5} afterAbandon={afterAbandon} />;
    $[7] = afterAbandon;
    $[8] = mailingSplitTestId;
    $[9] = opened;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t4 || $[12] !== t6) {
    t7 = <>{t4}{t6}</>;
    $[11] = t4;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  return t7;
}